export default {"src":"/_next/static/media/homeSeven.5600a27f.svg","height":588,"width":561,"blurWidth":0,"blurHeight":0};